module.exports = __webpack_public_path__ + "static/299fbdf4df2825a3fe3ee342706bfa0c618a9e122cd55a4b4ae816d59ba62bff-9e86ed8c941ee018719f58beda28e449.jpeg";